export const CHANNEL = 'NDS';
export const SEARCH_TYPE = 'manual';

export const CLICK_INTERACTION_IDENTIFIER = 'isPLPClickInteracted';

export const EVENT_TYPES = {
  SORT_CLICK: 'sort-click',
  CLEAR_ALL_CLICK: 'clear-all-click',
  PRODUCT_CARD_CLICK: 'product-card-click',
  FILTERS_UPDATED: 'filters-updated',
};
